/** Hash routes for public marketing + app shell (no react-router). */

/** Console pages that live inside the authenticated app shell. */
export const CONSOLE_PAGES = [
  "dashboard",
  "dashboards",
  "evidence",
  "log-analysis",
  "rca",
  "release-notes",
  "chat",
  "logs",
  "kb",
  "docs",
  "learn-topics",
  "learn-k8s",
  "incidents",
  "changes",
  "cmdb",
  "agents",
  "analytics",
  "users",
  "billing",
  "apikeys",
  "integrations",
  "audit",
  "notifs",
  "settings",
];

const CONSOLE_PAGE_SET = new Set(CONSOLE_PAGES);

function normalizePath(hash) {
  const source =
    hash !== undefined && hash !== null
      ? hash
      : typeof window !== "undefined"
        ? window.location.hash
        : "#/";
  const raw = String(source || "#/").replace(/^#\/?/, "").trim();
  return raw.split("?")[0].replace(/\/$/, "") || "landing";
}

/**
 * Parse the current hash into a top-level route + optional console page.
 * Supports:
 *   #/                        → landing
 *   #/app                     → app / dashboard
 *   #/app/integrations        → app / integrations
 *   #/integrations            → app / integrations  (deep link)
 *   #/console                 → app / dashboard
 */
export function parseRoute(hash) {
  const path = normalizePath(hash);
  const parts = path.split("/").filter(Boolean);

  if (parts.length === 0 || parts[0] === "landing" || parts[0] === "home") {
    return { route: "landing", page: null };
  }
  if (parts[0] === "sign-up" || parts[0] === "signup") {
    return { route: "signup", page: null };
  }
  if (parts[0] === "sign-in" || parts[0] === "signin" || parts[0] === "login") {
    return { route: "signin", page: null };
  }

  // #/app, #/app/<page>, #/console, #/dashboard
  if (parts[0] === "app" || parts[0] === "console" || parts[0] === "dashboard") {
    const page =
      parts[0] === "dashboard"
        ? "dashboard"
        : parts[1] && CONSOLE_PAGE_SET.has(parts[1])
          ? parts[1]
          : "dashboard";
    return { route: "app", page };
  }

  // Bare console page deep links: #/integrations, #/chat, …
  if (CONSOLE_PAGE_SET.has(parts[0])) {
    return { route: "app", page: parts[0] };
  }

  return { route: "landing", page: null };
}

/** Top-level route: landing | signup | signin | app */
export function getRoute(hash) {
  return parseRoute(hash).route;
}

/** Console page id when route is app (default dashboard). */
export function getConsolePage(hash) {
  return parseRoute(hash).page || "dashboard";
}

export function navigate(route, page) {
  if (route === "landing") {
    window.location.hash = "#/";
    return;
  }
  if (route === "signup") {
    window.location.hash = "#/signup";
    return;
  }
  if (route === "signin") {
    window.location.hash = "#/signin";
    return;
  }
  if (route === "app") {
    const p = page && CONSOLE_PAGE_SET.has(page) ? page : null;
    window.location.hash = p && p !== "dashboard" ? `#/app/${p}` : "#/app";
    return;
  }
  if (CONSOLE_PAGE_SET.has(route)) {
    window.location.hash = `#/app/${route}`;
    return;
  }
  window.location.hash = `#/${route}`;
}
